module.exports = __webpack_public_path__ + "static/anti-burglary-2da40f520ddcb2e50d9414b4a5324a4e.svg";